export default [{ label: "Email address", name: "email" }];
